"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CursorIcon;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * CursorIcon ~
*/
function CursorIcon(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "1064.7701 445.5539 419.8101 717.0565",
      enableBackground: "new 1064.7701 445.5539 419.8101 717.0565",
      xmlSpace: "preserve"
    }, /*#__PURE__*/_react["default"].createElement("polygon", {
      fill: "#231F20",
      points: "1283.1857,1127.3097 1406.1421,1077.6322 1314.2406,850.1678 1463.913,852.7823 1093.4828,480.8547 1085.4374,1005.6964 1191.2842,899.8454 "
    })))
  );
}